module.exports = __webpack_public_path__ + "images/vaidyaccc36cf693bd4795dc78014f1ebbeb8b.png";